<template>
<div>
  <pt-integral-goods-form ref="goodsForm" class="pt-integral-goods-form__withData" :goodsTypeLoading="goodsTypeLoading" :goodsTypes="goodsTypes"
  @getGoodsTypeList="getGoodsTypeList" :businessDepartments="businessDepartments" :addressList="addressList" :saveLoading="saveLoading" :submitLoading="submitLoading"
  :companyList="companyList" :goodsGroup="goodsGroup" :afterSalesPolicieList="afterSalesPolicieList"  :goods-form="form" :allMembers="allMembers"
  :carriagePoliciesList="carriagePoliciesList" :privacyPolicyList="privacyPolicyList" :goodsForm="formValue" @getCarriagePolicies="getCarriagePolicies"
  :getPrivacyPolicies="getPrivacyPolicies" @afterSalesPolicies="afterSalesPolicies" :isEdit="isEdit" :content="content"></pt-integral-goods-form>
</div>
</template>

<script>
import PtIntegralGoodsForm from './form'
const prefixCls = 'pt-integral-goods-form__withData'
export default {
  name: 'pt-integral-goods-form__withData',
  components: {
    'pt-integral-goods-form': PtIntegralGoodsForm
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    form () {
      return this.$refs.goodsForm
    }
  },
  props: {
    isEdit: Boolean,
    id: String
  },
  data () {
    return {
      goodsTypeLoading: false,
      goodsTypes: [],
      businessDepartments: [],
      addressList: [],
      companyList: [],
      goodsGroup: [],
      afterSalesPolicieList: [],
      carriagePoliciesList: [],
      privacyPolicyList: [],
      loading: false,
      formValue: {},
      goodsData: {},
      submitLoading: false,
      saveLoading: false,
      allMembers: [],
      content: ''
    }
  },
  methods: {
    // 获取商品分组列表
    getGoodsGroup () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 1000
        }
      }
      this.$store.dispatch('getIntegralGoodsGroups', data).then(res => {
        res.data.forEach(item => {
          if (!item.id !== 'goods-share') {
            this.goodsGroup.push(item)
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取商品分组列表失败')
      })
    },
    // 获取分子公司列表
    getCompanyList () {
      let data = {
        type: 'BRANCH',
        pageableParam: {
          page: 0,
          size: 9999
        }
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        // this.vendorsOrganizations = res.data
        this.companyList = res.data
      }).catch(err => {
        this.$message.error(err || '获取分子公司列表失败')
      })
    },
    getAreatList () {
      this.$store.dispatch('getBusinessArea').then(data => {
        let options = []
        data.forEach(item => {
          let signalItem = {
            label: item.name,
            value: item.value
          }
          options.push(signalItem)
        })
        this.addressList = options
      })
    },
    getBusinessDepartment () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        this.businessDepartments = res
      }).catch(err => {
        this.$message.error(err || '获取业务部列表失败')
      })
    },
    // 根据商品归属获取商品类型列表
    getGoodsTypeList (belong) {
      let data = {
        belong: belong || 'PLATFORM'
      }
      this.goodsTypeLoading = true
      this.$store.dispatch('getIntegralGoodsTypes', data).then(res => {
        this.goodsTypeLoading = false
        this.goodsTypes = res
      }).catch(err => {
        this.goodsTypeLoading = false
        this.$message.error(err || '获取商品类型列表失败')
      })
    },
    // 获取售后政策列表
    afterSalesPolicies (selectId) {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getIntegralAfterSalesPolicies', data).then(res => {
        this.afterSalesPolicieList = res.data
        // this.afterSalesPolicieList.unshift({
        //   id: 'null',
        //   name: '无'
        // })
      }).catch(err => {
        this.$message.error(err || '获取售后政策列表失败')
      })
    },
    // 获取运费规则列表
    getCarriagePolicies () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getIntegralaCarriagePolicies', data).then(res => {
        this.carriagePoliciesList = res.data
      }).catch(err => {
        this.$message.error(err || '获取运费规则失败')
      })
    },
    // 获取隐私规则列表
    getPrivacyPolicies () {
      let data = {
        page: 0,
        size: 9999
      }
      this.$store.dispatch('getIntegralPrivacyPolicies', data).then(res => {
        this.privacyPolicyList = res.data
      }).catch(err => {
        this.$message.error(err || '获取隐私条款失败')
      })
    },
    // 获取商品详情
    getGoodsDetail () {
      this.loading = true
      let data = {
        id: this.id,
        isEdit: true
      }
      this.$store.dispatch('getIntegralGoodsDetail', data).then(res => {
        this.loading = false
        this.formValue = res
        let goodsData = res.goodsDTO.goodsData
        this.content = goodsData.detail
        this.getGoodsTypeList(goodsData.goodsBelong)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取商品详情失败')
      })
    },
    submitValidate () {
      this.form.validate().then(formValue => {})
    },
    // 获取全部会员等级列表
    getAllMembers () {
      this.loading = true
      this.$store.dispatch('getAllMembers').then(res => {
        this.loading = false
        this.allMembers = res.data
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取会员等级失败')
      })
    },
    submit (form) {
      // let data=this.form.goodsForm&&this.form.goodsForm.form
      // this.form.validate().then(formValue => {
      let goodsData = form.goodsDTO.goodsData
      goodsData.branche = []
      this.goodsGroup.forEach(item => {
        if (item.id === goodsData.groupId) {
          goodsData.groupName = item.name
        }
      })
      this.businessDepartments.forEach(item => {
        if (item.id === goodsData.businessDepartmentId) {
          goodsData.businessDepartmentName = item.name
        }
      })
      goodsData.branches = []
      this.companyList.forEach(item => {
        goodsData.branchesId.forEach(etem => {
          if (item.id === etem) {
            goodsData.branches.push(item)
          }
        })
      })
      this.submitLoading = true
      this.saveLoading = true
      let data = JSON.parse(JSON.stringify(form))
      this.$store.dispatch('saveIntegralGoods', data).then(res => {
        this.submitLoading = false
        this.saveLoading = false
        this.$message.success((this.isEdit ? '编辑' : '新建') + '商品成功')
        // this.$router.push('/goods-of-integral')
        history.go(-1)
        // doing something ...
      }).catch(errorMessage => {
        this.submitLoading = false
        this.saveLoading = false
        this.$message.error(errorMessage || ((this.isEdit ? '编辑' : '新建') + '商品成功'))
      })
      // })
    }
  },
  created () {
    this.getGoodsTypeList()
    this.getBusinessDepartment()
    this.getAreatList()
    this.getCompanyList()
    this.getGoodsGroup()
    this.afterSalesPolicies()
    this.getCarriagePolicies()
    this.getPrivacyPolicies()
    this.getAllMembers()
    if (this.isEdit) {
      this.getGoodsDetail()
    }
  }
}
</script>
